import React, { FC } from 'react';
import { useTranslations } from '@lang';
import { Button, StickyBarWrapper, StickyBarContent } from '@common/components';
import { Price, Discount } from 'shared-types/Common';

interface SpaStickyBarProps {
  displayedPrice: Price;
  id: string;
  isModalOpen?: boolean;
  name: string;
  onSubmit: () => void;
  displayPriceRangeIndicator: boolean;
  discountedPrice?: Discount | null;
  numberOfGuests?: number;
}

export const SpaStickyBar: FC<SpaStickyBarProps> = ({
  displayedPrice,
  id,
  isModalOpen = false,
  name,
  onSubmit,
  displayPriceRangeIndicator = false,
  discountedPrice,
  numberOfGuests,
}) => {
  const { t } = useTranslations();

  return (
    <StickyBarWrapper
      id={id}
      // if modal is open, sticky bar should be above navmenu and flynav
      zIndex={isModalOpen ? 9999 : undefined}
    >
      {!isModalOpen ? (
        <StickyBarContent
          // render initial content for StickyBar that could be changed by portal in another
          // wizard steps
          name={name}
          displayPriceRangeIndicator={displayPriceRangeIndicator}
          displayedPrice={displayedPrice}
          numberOfGuests={numberOfGuests}
          discountedPrice={discountedPrice}
          button={
            <Button
              isPrimary
              onClick={onSubmit}
              type="button"
              ariaLabel={`${t('spa.book')} - ${name}`}
            >
              {t('spa.book')}
            </Button>
          }
        />
      ) : null}
    </StickyBarWrapper>
  );
};
